Array.prototype.remove = function(value) {
  let idx = this.indexOf(value);
  if (idx !== -1) {
    // Второй параметр - число элементов, которые необходимо удалить
    return this.splice(idx, 1);
  }
  return false;
};